import React from 'react';
import { withTranslation } from 'react-i18next';
import clsx from 'clsx';
import { FallbackProps } from 'react-error-boundary';
import { t } from 'i18next';
import { Typography } from '@mui/joy';
import styles from './view.module.scss';
import Log from '../../util/log';

function View({ error }: FallbackProps): JSX.Element {
  Log.error('[ErrorBoundary]', error);
  return (
    <div role="alert" className={clsx(styles.container)}>
      <main className={clsx(styles.innerContainer)}>
        <Typography className={clsx(styles.text)} component="h1" level="h4">
          {t('errors_v2.default.title')}
        </Typography>
        <Typography className={clsx(styles.text)} level="body-md">
          {t('errors_v2.default.body')}
        </Typography>
      </main>
    </div>
  );
}

export default withTranslation()(View);
